'use client'

import { InView } from 'react-intersection-observer'
import { useRef } from 'react'

import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import {
  impressionEvent,
  ClosetModel,
  VasEntryPointModel,
  VasEntryPoint,
  ContentSource,
} from '@marketplace-web/vas/vas-data'

import ClosetPromotion from './ClosetPromotion'

type Props = {
  closet: ClosetModel
  vasEntryPoints?: Array<VasEntryPointModel>
  position: number
  contentSource: ContentSource
  searchSessionId: string
  searchCorrelationId: string
  globalSearchSessionId: string | null
  globalCatalogBrowseSessionId: string | null
  onClick?: () => void
}

const CatalogClosetPromotion = ({
  closet,
  vasEntryPoints,
  position,
  contentSource,
  searchSessionId,
  searchCorrelationId,
  globalSearchSessionId,
  globalCatalogBrowseSessionId,
  onClick,
}: Props) => {
  const { track } = useTracking()

  const isSeen = useRef(false)

  const closetPromoBanner = closet.showBanner
    ? vasEntryPoints?.find(entryPoint => entryPoint.name === VasEntryPoint.PromotedClosets)
    : undefined

  const handleVisible = (inView: boolean) => {
    if (isSeen.current) return
    if (!inView) return

    isSeen.current = true

    track(
      impressionEvent({
        id: closet.user.id,
        position,
        contentType: 'promoted_closet',
        contentSource: 'promoted_closets',
        searchSessionId,
        searchCorrelationId,
        globalSearchSessionId,
        globalCatalogBrowseSessionId,
      }),
    )
  }

  return (
    <InView onChange={handleVisible} data-testid={`closet-promotion-${closet.user.id}`}>
      <ClosetPromotion
        onClick={onClick}
        banner={closetPromoBanner}
        closet={closet}
        position={position}
        contentSource={contentSource}
      />
    </InView>
  )
}

export default CatalogClosetPromotion
